var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.showNotification)?_c('div',{staticClass:"notification pointer",class:_vm.notificationType,on:{"click":function($event){_vm.showNotification = false}}},[_vm._v(" "+_vm._s(_vm.notificationMessage)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }